"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ExternalApiMessageType;

(function (ExternalApiMessageType) {
  ExternalApiMessageType["info"] = "info";
  ExternalApiMessageType["warning"] = "warning";
  ExternalApiMessageType["error"] = "error";
  ExternalApiMessageType["success"] = "success";
})(ExternalApiMessageType = exports.ExternalApiMessageType || (exports.ExternalApiMessageType = {}));